import { render } from "./ApprovePaymentLiquidations.vue?vue&type=template&id=5777462c"
import script from "./ApprovePaymentLiquidations.vue?vue&type=script&lang=js"
export * from "./ApprovePaymentLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__